module.exports = __webpack_public_path__ + "static/media/Cookies-and-Tracking-Technologies.6fda619c.pdf";